import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays a lozenge badge for menu items with custom label and colors.
 *
 * @function
 * @param       {object} lozenge lozenge object with label, textColour, and backgroundColour.
 * @constructor
 */
function Lozenge({ lozenge }) {
    if (!lozenge) {
        return null;
    }

    const style = {
        backgroundColor: lozenge.backgroundColour,
        borderColor: lozenge.backgroundColour,
        color: lozenge.textColour
    };

    return (
        <i className="flag" style={style}>
            {lozenge.label}
        </i>
    );
}

export { Lozenge };

Lozenge.propTypes = {
    lozenge: PropTypes.shape({
        label: PropTypes.string,
        textColour: PropTypes.string,
        backgroundColour: PropTypes.string
    })
};
